/*
 * @author Mateusz Mieszczak <mateusz.mieszczak at bossbyte.com>
 * @copyright BossByte Web Application
 */


app.controller('MessageTemplateDetails', function($scope, $stateParams, $rootScope,
    templateService, _$editmode, _$privileges, $mdDialog) {

    _$editmode.turnOff();

    $scope.id = $stateParams.id;

    $scope.tab = {
        "selected": 0,
        "change": function(kind) {
            $scope.tab.selected = kind == 'next' ? $scope.tab.selected + 1 : $scope.tab.selected - 1;
        },
        "title": "Szczegóły szablonu wiadomości",
        "kind": "template",
        "button": "Zapisz",
        "editable": false,
        "details": true
    };

    $scope.row = {};

    $scope.data = {
        "can_write": _$privileges.write("message"),
        "copy_template_name": "",
        "emailsettings": {},
        "subunit": false,
        "subunit_id": false,
        "languages": []
    };

    $scope.autocompletes = {
        "county": [],
        "city": [],
        "comunity": [],
        "street": []
    };

    $scope.search = {
        clearButton: false,
        "list": {}
    };

    $scope.notavailable = {
        "sms": false,
        "mobile": true,
        "email": false,
        "epuap": false,
        "available_to": true
    };

    $scope.init = function() {
        var promise = templateService.show($scope.id);
        promise.then(
            function(payload) {
                if (payload.data.row.length == 0) {
                    $rootScope.notification.showAfterRedirect('message_templates', {}, 'error', 'Wybrany szablon nie została odnaleziony');
                } else {
                    $rootScope.filters = payload.data.filters;

                    $scope.data.categories = payload.data.categories;
                    $scope.data.languages = payload.data.languages;
                    $scope.search.list = payload.data.list;
                    $scope.data.notifications = payload.data.notifications;
                    $scope.row = payload.data.row;                    

                    $scope.row.priority = payload.data.row.content.notification;
                    $scope.data.emailsettings = payload.data.emailsettings;
                    $scope.data.subunit = payload.data.subunit;
                    $scope.data.subunit_id = payload.data.subunit_id;

                    var county = $scope.row.content.filter.county.split(",");
                    for (var i = 0; i < county.length; i++) {
                        if (county[i] != "") {
                            $scope.autocompletes.county.push({
                                name: county[i],
                                readonly: true
                            });
                        }
                    }
                    var comunity = $scope.row.content.filter.comunity.split(",");
                    for (var i = 0; i < comunity.length; i++) {
                        if (comunity[i] != "") {
                            $scope.autocompletes.comunity.push({
                                name: comunity[i],
                                readonly: true
                            });
                        }
                    }
                    var city = $scope.row.content.filter.city.split(",");
                    for (var i = 0; i < city.length; i++) {
                        if (city[i] != "") {
                            $scope.autocompletes.city.push({
                                name: city[i],
                                readonly: true
                            });
                        }
                    }
                    var street = $scope.row.content.filter.street.split(",");
                    for (var i = 0; i < street.length; i++) {
                        if (street[i] != "") {
                            $scope.autocompletes.street.push({
                                name: street[i],
                                readonly: true
                            });
                        }
                    }

                    if (typeof $scope.row != "undefined" && $scope.row.content.filter.age != null && $scope.row.content.filter.age != "") {
                        var age = $scope.row.content.filter.age.split("_");
                        if (age[0] == "date") {
                            $scope.row.content.filter.age_before = new Date($scope.row.content.filter.age_before);
                            if ($scope.row.content.filter.age_after != "")
                                $scope.row.content.filter.age_before = new Date($scope.row.content.filter.age_before);
                        } else {
                            $scope.row.content.filter.age_before = parseInt($scope.row.content.filter.age_before, 10);
                            if ($scope.row.content.filter.age_after != "")
                                $scope.row.content.filter.age_after = parseInt($scope.row.content.filter.age_after, 10);
                        }
                    }

                    if (typeof payload.data.receiver_list != "undefined")
                        $scope.data.receiver_list = payload.data.receiver_list;

                    $scope.notavailable.available_to = $scope.row.content.notification.indexOf(parseInt($scope.mobileNotificationId)) == -1;
                }
            },
            function(errorPayload) {
                $rootScope.notification.show('error', 'Wystąpił błąd podczas próby wyświetlenia szablonu wiadomości');
            });
    };

    $scope.init();

    $scope.delete = function() {
        var promise = templateService.delete($scope.id);
        promise.then(
            function(payload) {
                if (payload.data.code == 1) {
                    $rootScope.notification.showAfterRedirect('message_templates', {}, 'success', payload.data.msg);
                } else {
                    $rootScope.notification.show('error', payload.data.msg);
                }
            },
            function(errorPayload) {
                $rootScope.notification.show('error', 'Wystąpił błąd podczas próby usuwania szablonu wiadomości');
            });
    };

    $scope.panel = {
        "copy": {
            "name": "",
            "show": function() {
                var parentEl = angular.element(document.body);
                $mdDialog.show({
                    parent: parentEl,
                    controller: function() {
                        this.parent = $scope;
                    },
                    controllerAs: 'ctrl',
                    templateUrl: "/assets/js/angular/message/views/modal/template_copy.html?v=2"
                });
            },
            "commit": function() {
                var promise = templateService.copy({
                    "id": $scope.id,
                    "name": $scope.panel.copy.name
                });
                promise.then(
                    function(payload) {
                        $rootScope.notification.show(payload.data.code ? 'success' : 'error', payload.data.msg);
                        $scope.panel.copy.name = "";
                    });
                $mdDialog.hide();
            },
            "cancel": function() {
                $mdDialog.cancel();
            }
        }
    };

    $scope.createmsg = function() {
        var promise = templateService.createmsg($scope.id);
        promise.then(
            function(payload) {
                if (payload.data.code == 1) {
                    $rootScope.notification.showAfterRedirect('message_drafts_msgedit', {
                        id: payload.data.id
                    }, 'success', payload.data.msg);
                } else {
                    $rootScope.notification.show('error', payload.data.msg);
                }
            },
            function(errorPayload) {
                $rootScope.notification.show('error', 'Wystąpił błąd podczas próby powielenia szablonu wiadomości');
            });
    };

    $scope.sendMethodChange = function() {
        //        if($scope.row.priority.length!=$scope.row.content.notification.length){
        //            $scope.row.priority = angular.copy($scope.row.content.notification);
        //        }
    };
});
